import React from 'react';
import PAYMENT_CHANNELS from './paymentChannels.json';
import Select, { components } from 'react-select';
import {Button} from "reactstrap";


const maxDisplayed = 4;

const CustomMultiValue = (props) => {
  const { data, selectProps } = props;
  const { value } = selectProps;

  // Define your limit here


  if (value.length > maxDisplayed && data === value[maxDisplayed - 1]) {
    // If more than maxDisplayed selected, and this is the last visible item,
    // display "N more"
    return (
      <components.MultiValue {...props}>
        +{value.length - maxDisplayed} more
      </components.MultiValue>
    );
  } else if (value.length > maxDisplayed && value.indexOf(data) >= maxDisplayed) {
    // If more than maxDisplayed selected, and this item is beyond the limit,
    // do not render it
    return null;
  }

  // Otherwise, render the default MultiValue
  return <components.MultiValue {...props} />;
};

const CustomMultiValueRemove = (props) => {
    const { data, selectProps } = props;
    const { value } = selectProps;

    if (value.length > maxDisplayed && data === value[maxDisplayed - 1]) {
        return null
    } else if (value.length > maxDisplayed && value.indexOf(data) >= maxDisplayed) {
        return null;
    }

    return <components.MultiValueRemove {...props} />;
}


const CustomCheckboxOption = (props) => {
    const { data, selectProps } = props;
    const { value } = selectProps;

    return (
        <components.Option {...props}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
            />{" "}
            <label>{props.label}</label>
        </components.Option>
    )
}

export default function SettingEditorFieldPaymentMethod({value, originalValue, setValue}) {
    const groupedOptions = PAYMENT_CHANNELS.payment_methods.map(method => ({
        label: method.method,
        options: method.channels.filter(channel => {
            return channel.availability === "Available"
        }).map(channel => ({
            label: channel.description,
            value: channel.code,
            method: method.method,
        }))
    }));

    const flatOptions = groupedOptions.flatMap(group => group.options);
    const selectedOptions = flatOptions.filter(option => value.channel.includes(option.value));


    return (
        <>

            <small>
                Please note that not all payment channels below will appear on the list of channels during payment.
                Paynamics has pre-configured your allowed payment channels prior to integration; even if you indicated
                any of the pchannels below on your request, and it's not enabled on Paynamics configuration it will not
                appear on the RPF page. To request to enable such channels, please contact your project manager or
                account officers to assist you.
            </small>

        <Select
            value={selectedOptions}
            onChange={(selected) => {
                const selectedChannels = selected ? [...new Set(selected.map(option => option.value))] : [];
                const selectedMethods = selected ? [...new Set(selected.map(option => option.method))] : [];

                setValue({
                    ...value,
                    channel: selectedChannels,
                    method: selectedMethods,
                });
            }}
            isMulti
            options={groupedOptions}
            isClearable
            placeholder="All available payment methods"
            maxMenuHeight={200}
            formatValueLabel={(value, meta) => {
                if (meta.getValue().length > 5 && meta.getValue().indexOf(value) >= 5) {
                    return null;
                }
                return value.label;
            }}
            valueLabel={(valueArray) => {
                if (valueArray.length > 5) {
                    return `${valueArray.slice(0, 5).map(v => v.label).join(', ')} and ${valueArray.length - 5} more...`;
                }
                return valueArray.map(v => v.label).join(', ');
            }}
            components={{
                MultiValue: CustomMultiValue,
                MultiValueRemove: CustomMultiValueRemove,
                Option: CustomCheckboxOption,
        }}
            hideSelectedOptions={false}

        />
            <Button color="link" size="sm" className="ms-2" onClick={() => {

                const selectedChannels = [...new Set(flatOptions.map(option => option.value))];
                const selectedMethods = [...new Set(flatOptions.map(option => option.method))];

                setValue({
                    ...value,
                    channel: selectedChannels,
                    method: selectedMethods,
                });
            }}>
                SELECT ALL
            </Button>

            </>
    );


}